import { Stack } from '@servicetitan/design-system';
import styled from 'styled-components';

export const SpinnerStack = styled(Stack)`
  min-height: 116px;
`;
